import { differenceWith, get, omit } from "lodash-es"
import React from "react"
import { useDispatch } from "react-redux"
import DeleteDialog from "components/Organisms/DeleteDialog"
import AppToaster from "utils/AppToaster"
import { DELETE_SCHEDULES } from "graphql/scheduling/scheduling.mutations.gql"
import {
  SCHEDULE_LIST,
  SCHEDULE_LIST_SUMMARY,
} from "graphql/scheduling/scheduling.queries.gql"
import { useAuthorizationModules } from "hooks/useAuth"
import ReactGA from "../../services/analytics.service"
import {
  DELETE_SCHEDULES as DELETE_SCHEDULES_REDUX,
  useSchedulingVariables,
} from "store/scheduling.redux"
import { isPast } from "utils/custom.utils"
const DeleteSchedules = ({ isOpen, onClose, title, schedules, children }) => {
  const dispatch = useDispatch()
  const variables = useSchedulingVariables()

  const disabled = useAuthorizationModules("delete_previous", "schedule")
  return (
    <DeleteDialog
      disabled={isPast(variables?.date) ? disabled : false}
      isOpen={isOpen}
      onClose={onClose}
      mutation={DELETE_SCHEDULES}
      refetchQueries={[
        {
          query: SCHEDULE_LIST_SUMMARY,
          variables: omit(variables, ["first", "skip"]),
        },
      ]}
      variables={{
        schedules,
      }}
      onCompleted={data => {
        const deletedSchedules = get(data, "delSchedules.schedules")
        AppToaster.show({
          message: `${deletedSchedules.length} Schedules Deleted successfully`,
          intent: "success",
        })

        dispatch({
          type: DELETE_SCHEDULES_REDUX,
          payload: deletedSchedules,
        })
        onClose(data)
        ReactGA.event({
          category: "Scheduling",
          action: "Deleted Schedules",
          value: deletedSchedules?.length,
        })
      }}
      onError={errors => {
        AppToaster.show({
          message: `Schedule could not be deleted`,
          intent: "danger",
        })
      }}
      update={(cache, data) => {
        const deletedSchedules = get(data, "data.delSchedules.schedules")

        const { schedulesForDate } = cache.readQuery({
          query: SCHEDULE_LIST,
          variables,
        })

        cache.writeQuery({
          query: SCHEDULE_LIST,
          variables,
          data: {
            schedulesForDate: differenceWith(
              schedulesForDate,
              deletedSchedules,
              (sc, sch) => {
                return parseInt(sc.id) === parseInt(sch)
              }
            ),
          },
        })

        cache.writeQuery({
          query: SCHEDULE_LIST,
          variables: omit(variables, ["first", "skip"]),
          data: {
            schedulesForDate: differenceWith(
              schedulesForDate,
              deletedSchedules,
              (sc, sch) => {
                return parseInt(sc.id) === parseInt(sch)
              }
            ),
          },
        })
      }}
      title={title}
    >
      {children}
    </DeleteDialog>
  )
}

DeleteSchedules.defaultProps = {
  title: "Delete Schedules",
}
export default DeleteSchedules
